export const DEFAULT_PAGE_SIZE = 40

export enum NodeTypes {
  FILE = 'file',
  LINK = 'link',
  DIR = 'dir',
}

export enum WSActions {
  CREATED = 'created',
  DELETED = 'deleted',
  CHANGED = 'changed',
}
